import React from "react";
import { Arc, Group } from "react-konva";

const DoubleGateShapte = ({ shape, shapeProps }) => {
	return (
		<Group
			key={shape.id}
			{...shapeProps}
			x={shape.x}
			y={shape.y}
			width={shape.width}
		>
			<Arc
				x={0}
				y={0}
				angle={90}
				innerRadius={0}
				outerRadius={shape.width / 2}
				rotation={270}
				fill="transparent"
				stroke="black"
				strokeWidth={2}
			/>
			<Arc
				x={shape.width * 1}
				y={0}
				angle={90}
				innerRadius={0}
				outerRadius={shape.width / 2}
				rotation={180}
				fill="transparent"
				stroke="black"
				strokeWidth={2}
			/>
		</Group>
	);
};

export default DoubleGateShapte;
